require('../../modules/es6.array.of');
module.exports = require('../../modules/_core').Array.of;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/array/of.js
// module id = 841
// module chunks = 34